<div class="container">
    <div class="row">
        <div class="col-xs-12">
            <p class="text-muted" *ngIf="parentFolderName">Add folder to <b>{{parentFolderName}}</b> folder.</p>
            <form #documentFolderForm="ngForm" novalidate>
                <div class="form-group col-xs-4" [ngClass]="{'has-error': (documentFolderForm.submitted && name.invalid)}">
                    <label for="name" class="control-label">
                        Folder Name<em>* </em> :
                    </label>
                    <input type="text"
                        class="form-control"
                        id="name"
                        name="name"
                        #name="ngModel"
                        [(ngModel)]="folder.name"
                        required
                        maxlength="100">
                    <div style="color:red;" *ngIf="documentFolderForm.submitted && name.errors?.pattern">
                        <small class="error">{{MESSAGECONSTANTS.COMMONVALIDATIONS.FIRST_NAME}}</small>
                    </div>
                    <div style="color:red;" *ngIf="documentFolderForm.submitted && name.errors?.maxlength">
                        <small class="error">Folder name can have maximum 100 characters.</small>
                    </div>
                </div>

                <div class="form-group col-xs-9" [ngClass]="{'has-error': (documentFolderForm.submitted && description.invalid)}">
                    <label for="description" class="control-label">
                        Description :
                    </label>
                    <input type="text"
                        class="form-control"
                        id="description"
                        name="description"
                        #description="ngModel"
                        [(ngModel)]="folder.description">
                </div>

                <div class="col-xs-12" *ngFor="let documentType of folder.documentTypes">
                    <div class="panel panel-default">
                        <div class="panel-body">
                            <div class="form-group">
                                <label for="name" class="control-label">
                                    Document Type<em>* </em> :
                                </label>
                                <input type="text"
                                    class="form-control"
                                    name="name"
                                    [(ngModel)]="documentType.name"
                                    required
                                    maxlength="100">
                            </div>

                            <div class="form-group">
                                <label for="description" class="control-label">
                                    Description :
                                </label>
                                <input type="text"
                                    class="form-control"
                                    name="description"
                                    [(ngModel)]="documentType.description">
                            </div>

                            <div class="form-group checkbox-nice">
                                <input type="checkbox" [(ngModel)]="documentType.isShared" id="shared" name="shared">
                                <label for="shared">Share Externally</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-xs-12 text-right">
                    <div class="clearfix">
                        <button type="button" class="btn btn-danger mr-2" (click)="cancel()" [disabled]="savingFlag">
                            <span>Cancel</span>
                        </button>
                        <button type="submit" class="btn btn-success" (click)="save()" [disabled]="savingFlag">
                            <span *ngIf="!savingFlag">Save</span>
                            <span *ngIf="savingFlag">Saving..</span>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
